import styled from 'styled-components'
import {shade} from 'polished'

export const VideoChamada = styled.div`
    margin: 24px 0;
    padding: 0 24px;
    display: flex;
`

export const MainInfo = styled.div`
    padding-top: 10px;
    display: flex;
`

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 15px;
    strong {
        margin-bottom: 5px;
    }
`

export const Button = styled.button`
    color: #fff;
    padding: 10px 16px;
    border-radius: 8px;
    background-color: #f3123c;
    display: flex;
    align-items: center;
    margin-left: 155px;
    @media(max-width: 1366px) {
        margin-left: 70px;
    }
    font-weight: bold;
    font-size: 12px;
    line-height: 150%;
    transition: background-color .3s;
    cursor: pointer;

    &:hover {
        background-color: ${shade(0.2, '#f3123c')};
        transition: background-color .3s;
    }
`

export const IconVideo = styled.img`
    width: 20px;
    height: 20px;
    margin-left: 5px;
`
